module.exports = __webpack_public_path__ + "img/bg17.e882b5b2.jpg";